import { render, staticRenderFns } from "./SingleDieResult.vue?vue&type=template&id=74c5879e&scoped=true"
import script from "./SingleDieResult.vue?vue&type=script&lang=js"
export * from "./SingleDieResult.vue?vue&type=script&lang=js"
import style0 from "./SingleDieResult.vue?vue&type=style&index=0&id=74c5879e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c5879e",
  null
  
)

export default component.exports